import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  register: [],
  payment: false,
  subscriptionType: null,
  subscriptionPrice: 0,
  selectedOptions: {
    combine: true,
    positionDrill: false,
    subscription: false,
  },
};

const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    registerAccountStore: (state, action) => {
      state.register = [action.payload];
    },
    setSubscriptionDetails: (state, action) => {
      state.subscriptionType = action.payload.subscriptionType;
      state.subscriptionPrice = action.payload.subscriptionPrice;
      state.selectedOptions = action.payload.selectedOptions;
    },
    clearRegisterData: (state) => {
      state.register = [];
      state.subscriptionType = null;
      state.subscriptionPrice = 0;
      state.selectedOptions = {
        combine: true,
        positionDrill: false,
        subscription: false,
      };
    },
    paymentLoaded: (state, action) => {
      state.payment = action.payload;
    },
  },
});

export const {
  registerAccountStore,
  setSubscriptionDetails,
  clearRegisterData,
  paymentLoaded,
} = accountSlice.actions;

export default accountSlice.reducer;
